<template>
  <div class="app-container">
    <header>
      <div class="header-content">
        <div class="logo-section">
          <img v-if="theme" src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载" @click="gohome">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png" alt="待加载" @click="gohome">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="header-spacer"></div>
        <div class="header-actions">
          <div class="home-btn" @click="gohome">
            <span class="iconfont">&#xe632;</span>
            <span>返回主页</span>
          </div>
          <div class="header-btn" @click="handleGoToImageLog">
            <span class="iconfont">&#xe605;</span>
            <span>生图记录</span>
          </div>
          <div class="header-btn" @click="handelDissvisible(1)">
            <span class="iconfont">&#xe67c;</span>
            <span>讨论区</span>
          </div>
          <div class="user-avatar">
            <img :src="avatar" alt="待加载">
          </div>
        </div>
      </div>
    </header>
    <div class="body">
      <div class="content-wrapper">
        <!-- 左侧:上传图片 + 参数 -->
        <div class="upload-section">
          <div class="upload-card">
            <div class="section-title">上传图片</div>
            <div class="upload-area" @click="handleImageUploadClick" @dragover.prevent @drop="handleImageDrop" v-loading="loading">
              <div v-if="imagePath" class="close-btn" @click.stop="deleteImage">×</div>
              <div v-if="!imagePath" class="upload-placeholder">
                <div class="upload-icon">🖼️</div>
                <div class="upload-text">拖拽图片或点击上传</div>
                <div class="upload-button">上传</div>
              </div>
              <img v-if="imagePath" :src="imagePath" class="uploaded-image">
            </div>
            <div class="upload-tips">
              <div class="tip-item">
                <span class="tip-label">上边缘:</span>
                <input type="number" class="param-input" v-model="top" min="0" max="512">
              </div>
              <div class="tip-item">
                <span class="tip-label">下边缘:</span>
                <input type="number" class="param-input" v-model="bottom" min="0" max="512">
              </div>
              <div class="tip-item">
                <span class="tip-label">左边缘:</span>
                <input type="number" class="param-input" v-model="left" min="0" max="512">
              </div>
              <div class="tip-item">
                <span class="tip-label">右边缘:</span>
                <input type="number" class="param-input" v-model="right" min="0" max="512">
              </div>
              <div class="tip-item">
                <span class="tip-label">羽化值:</span>
                <input type="number" class="param-input" v-model="feather" min="0" max="512">
              </div>
              <div class="tip-item">
                <span class="tip-label">文件大小:</span>
                <span class="tip-value">10MB及以下</span>
              </div>
              <div class="tip-item">
                <span class="tip-label">文件格式:</span>
                <span class="tip-value">JPG、PNG、WEBP</span>
              </div>
              <div class="tip-desc">建议上传分辨率在4000×4000以内的图片。支持Ctrl+V粘贴图片地址。</div>
            </div>
          </div>
        </div>

        <!-- 右侧:输出图片 -->
        <div class="output-section">
          <div class="output-card">
            <div class="section-title">输出图片</div>
            <div class="output-area">
              <div v-if="processedImage" class="close-btn" @click.stop="clearOutput">×</div>
              <div v-if="!processedImage && !tips" class="output-placeholder">
                <div class="output-icon">🎨</div>
                <div class="output-text">在线生成</div>
              </div>
              <img v-if="processedImage" :src="processedImage" class="output-image" @click="handleOutputImageClick">
              <div v-if="tips" class="processing-mask">
                <div class="processing-text">{{ tips }}</div>
              </div>
            </div>
            <div class="output-tips">
              <div class="tip-item">
                <div class="action-btn" @click="handleUpscale">智能剪裁</div>
                <div class="action-btn" @click="handleInpaint">局部重绘</div>
              </div>
              <div class="tip-desc">如需对图像进行裁剪调整，请选择智能剪裁。</div>
              <div class="tip-desc">对于图中不满意的部分可进行局部重绘。</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="bottom-actions">
        <div class="help-btn" @mouseenter="showHelpTip = true" @mouseleave="showHelpTip = false">
          使用说明
          <div v-if="showHelpTip" class="help-tooltip">
            <div class="tooltip-title">AI无界扩图使用说明</div>
            <div class="tooltip-content">
              <div class="tip-section">
                <p>为了获得更好的扩图效果，请注意以下要点：</p>
                <div class="section-title">通用提醒:</div>
                <p>建议上传分辨率在1600×1600以内的图片，以确保最佳处理效果。</p>
                <p>支持拖拽上传、点击上传和Ctrl+V粘贴图片地址。</p>
              </div>
              <div class="tip-section">
                <div class="section-title">关于边缘参数:</div>
                <p>上/下/左/右边缘：控制图像四个方向扩展的像素大小，范围0-512。</p>
                <p>羽化值：控制扩展边缘的羽化程度，数值越大过渡越自然。</p>
              </div>
              <div class="tip-section">
                <div class="section-title">处理时间:</div>
                <p>预计等待时间约13-15秒，请耐心等待。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="generate-btn" @click="start_process">开始扩图</div>
        <div class="save-btn" @click="handleSave">保存图片</div>
      </div>
    </div>
    <ImageModal class="modal" :visible="isModalVisible" :img_url="imageUrl" @update:visible="isModalVisible = $event"
      :img_show="false" :video_show="true" :video_src="video_src"></ImageModal>
    <!-- 图片预览组件（隐藏，点击时触发） -->
    <el-image
      ref="previewImage"
      style="display: none;"
      :src="previewUrl"
      :preview-src-list="[previewUrl]"
    />
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>

<script>
import { genOssImage } from '@/utils/ossPath'
import { v4 as uuidv4 } from 'uuid'
import random from 'random'
import { Message } from 'element-ui'
import { genPrompt } from '@/api/prompt'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import localStorageUtils from '@/utils/setLocalStorage'
import { getTaskEnd, getTaskStart, getTaskAppend } from '@/api/user'
import { T_IMAGE_SCALING } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'
import getImageDimensions from '@/utils/getImageDimensions'
import theme from '@/utils/theme'
import { mapGetters } from 'vuex'
import broadPictureWorkflow from '@/api/json_api/扩图Api.json'

export default {
  name: 'BroadPicture',
  computed: {
    ...mapGetters(['avatar'])
  },
  data() {
    return {
      taskLogId: '',
      value: false,
      imageSrc: '',
      imagePath: '',
      processedImage: '',
      tips: false,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      clientId: '',
      guidance: 30,
      top: 0,
      bottom: 0,
      left: 128,
      right: 128,
      feather: 64,
      loading: false,
      day: theme.day,
      night: theme.night,
      theme: true,
      // 防呆设计
      isModalVisible: false,
      imageUrl: '',
      img_show: false,
      video_src: '',
      // 评论区弹窗
      boardvisible: false,
      disscussType: null,
      // 新增字段
      showHelpTip: false,
      previewUrl: '' // 预览图片URL
    }
  },
  created() {
    this.imagePath = localStorageUtils.getItem('brodpicture')
    this.processedImage = localStorageUtils.getItem('brodpicture_showimage')
    // 将ID值赋给讨论区类型
    this.disscussType = T_IMAGE_SCALING
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
  },
  mounted() {
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    window.addEventListener('keydown', this.handleKeyPaste)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
    this.$nextTick(() => {
      this.source_html()
    })
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    window.removeEventListener('keydown', this.handleKeyPaste)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 修改dissboard的状态
    handelDissvisible(x) {
      if (x === 1) {
        this.boardvisible = true
      }
      if (x === 2) {
        Message.warning('😋开发者功能暂未开放,敬请期待~!')
      }
    },
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 跳转到生图记录页面
    handleGoToImageLog() {
      const targetPath = '/userimagelog'
      if (this.$router.history.current.fullPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    // 清空输出
    clearOutput() {
      this.processedImage = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('brodpicture_showimage')
    },
    // 智能剪裁功能(占位)
    handleUpscale() {
      Message.warning('😋开发者功能暂未开放,敬请期待~!')
    },
    // 局部重绘功能 - 跳转到PartialRedraw.vue并传入图片
    handleInpaint() {
      if (!this.processedImage) {
        Message.warning('😋请先生成图片,然后再进行局部重绘~!')
        return
      }
      // 将图片保存到localStorage供PartialRedraw.vue使用
      localStorageUtils.setItem('partialredraw_startimage', this.processedImage)
      // 记录传入其他功能行为
      if (this.taskLogId) {
        getTaskAppend({ action: 'transfer', url: this.processedImage, target: 'ai/d/t/partialredraw' }, this.taskLogId).catch(() => {})
      }
      // 跳转到PartialRedraw.vue页面
      this.$router.push({ path: '/partialredraw' })
    },
    // 保存功能(下载图片)
    async handleSave() {
      if (!this.processedImage) {
        Message.warning('😋请先生成图片,然后再进行保存~!')
        return
      }
      try {
        Message.info('正在下载图片...')
        const response = await fetch(this.processedImage)
        const blob = await response.blob()
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        const timestamp = new Date().getTime()
        link.download = `broadpicture_${timestamp}.png`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        Message.success('图片保存成功!')
        // 记录下载行为
        if (this.taskLogId) {
          try {
            await getTaskAppend({ action: 'download', url: this.processedImage }, this.taskLogId)
          } catch (e) {
            console.log('记录下载行为失败:', e)
          }
        }
      } catch (error) {
        console.error('保存图片失败:', error)
        Message.error('保存图片失败,请稍后再试!')
      }
    },
    // 防呆设计
    show_video(event) {
      event.preventDefault()
      event.stopPropagation()
      this.isModalVisible = true
      this.video_src = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/wan_move_show_video/%E4%B8%80%E9%94%AE%E6%89%A9%E5%9B%BE.mp4'
    },
    // 复制图像地址
    async copy_path(path) {
      if (!path) {
        Message.error('图像地址为空,请确认是否生成图像！')
        return
      }
      try {
        const textarea = document.createElement('textarea')
        textarea.value = path
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Message.success('复制内容成功,可进行下一步操作！')
      } catch {
        Message.error('复制内容失败,请稍后再试！')
      }
    },
    // 添加开始快捷键
    handleKeystart(event) {
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault()
        this.start_process()
      }
    },
    gohome() {
      this.$router.push({ path: '/' })
    },

    warningTips() {
      Message.warning('由于浏览器安全协议,请使用Ctrl + V 快捷键进行图片粘贴')
    },
    // 添加 Ctrl+V 快捷键处理
    async handleKeyPaste(event) {
      if (event.ctrlKey && event.key === 'v') {
        try {
          const textarea = document.createElement('textarea')
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.focus()
          const clipboardData = await new Promise((resolve, reject) => {
            textarea.addEventListener('paste', () => {
              setTimeout(() => {
                resolve(textarea.value)
              }, 10)
            })
            setTimeout(() => {
              reject(new Error('粘贴操作超时'))
            }, 2000)
          })
          document.body.removeChild(textarea)
          const imageRegex = /\.(png|jpe?g|gif|bmp|webp)$/i
          if (!imageRegex.test(clipboardData)) {
            Message.error('剪切板中的内容不是有效的图片地址（支持的格式：.png, .jpg, .jpeg, .gif, .bmp, .webp）')
          } else {
            this.imagePath = clipboardData
            localStorageUtils.setItem('brodpicture', clipboardData)
            Message.success('已从剪切板粘贴图片地址')
          }
        } catch (err) {
          Message.error('出现系统兼容性错误,请上报错误给开发者!')
        }
      }
    },
    // 上传图片到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/input/'
      const fileName = file.name
      console.log('上传到OSS:', tmp + fileName)
      try {
        const result = await ossClient.put(tmp + fileName, file)
        return result.url
      } catch (err) {
        return null
      }
    },
    // 点击上传按钮
    handleImageUploadClick() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          this.processImage(file)
        }
      }
      input.click()
    },
    // 拖拽上传事件
    handleImageDrop(event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]
      if (file && file.type.startsWith('image/')) {
        this.processImage(file)
      } else {
        Message.error('请上传有效的图片文件')
      }
    },
    //  图片处理函数
    async processImage(file) {
      this.loading = true
      const ossClient = await getOssClient()
      const imageUrl = await this.uploadToOSS(file, ossClient)
      try {
        const imageSize = await getImageDimensions(imageUrl)
        if (imageSize.width > 4000 || imageSize.height > 4000) {
          Message.error('图片尺寸过大,请重新上传!建议分辨率为4000*4000以内')
          this.loading = false
          return
        }
      } catch (error) {
        Message.error('获取图片尺寸失败:', error)
      }
      if (imageUrl) {
        this.imagePath = imageUrl
        console.log(imageUrl, typeof imageUrl)
        localStorageUtils.setItem('brodpicture', imageUrl)
        Message.success('图片加载成功,可以准备开始任务!')
      } else {
        Message.error('图片上传失败,请检查网络配置!')
      }
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
      }
      reader.readAsDataURL(file)
      this.loading = false
    },
    deleteImage() {
      this.imagePath = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('brodpicture')
      localStorage.removeItem('brodpicture_showimage')
    },
    // 替换工作流变量
    replaceWorkflowVariables(workflow, params) {
      const workflowCopy = JSON.parse(JSON.stringify(workflow))
      for (const nodeId in workflowCopy) {
        const node = workflowCopy[nodeId]
        if (node.inputs) {
          for (const inputKey in node.inputs) {
            const inputValue = node.inputs[inputKey]
            if (typeof inputValue === 'string') {
              if (inputValue.includes('{{IMAGE_URL}}')) {
                node.inputs[inputKey] = params.imageUrl
              } else if (inputValue.includes('{{OUTPUT_FILENAME}}')) {
                node.inputs[inputKey] = params.filename
              } else if (inputValue.includes('{{SEED}}')) {
                node.inputs[inputKey] = params.seed
              } else if (inputValue.includes('{{LEFT}}')) {
                node.inputs[inputKey] = params.left
              } else if (inputValue.includes('{{TOP}}')) {
                node.inputs[inputKey] = params.top
              } else if (inputValue.includes('{{RIGHT}}')) {
                node.inputs[inputKey] = params.right
              } else if (inputValue.includes('{{BOTTOM}}')) {
                node.inputs[inputKey] = params.bottom
              } else if (inputValue.includes('{{FEATHER}}')) {
                node.inputs[inputKey] = params.feather
              }
            }
          }
        }
      }
      return workflowCopy
    },
    // 应用函数
    start_process() {
      this.processedImage = ''
      if (this.imagePath === '' || this.imagePath === null) {
        Message.warning('请先选择图像文件')
        return
      }
      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      this.processing = true
      this.tips = '任务正在生成,预计等待13-15S.....'
      const seed = Math.floor(Math.random() * 10000000000000000)
      const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
      const promptData = this.replaceWorkflowVariables(broadPictureWorkflow, {
        imageUrl: this.imagePath,
        filename: filename,
        seed: seed,
        left: this.left,
        top: this.top,
        right: this.right,
        bottom: this.bottom,
        feather: this.feather
      })
      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return genPrompt(data)
        } catch (error) {
          console.error('发送作图请求失败：', error)
          this.processing = false
          this.tips = false
          return null
        }
      }
      const fetchImageFilename = async (promptId) => {
        try {
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })
          const response = await historyRequest.get(`/history/${promptId}`)
          const promptInfo = response.data[promptId]
          const promptIndex = 2 // prompt信息的下标
          const inputIndex = 157 // prompt信息组件名的下标(OSSUploadNode节点ID)
          if (promptInfo.status.status_str === 'success') {
            const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
            const imagepath = genOssImage(tmp[0])
            localStorageUtils.setItem('brodpicture_showimage', imagepath)
            this.getTaskEnd(imagepath, this.taskLogId)
            this.processedImage = imagepath
            this.processing = false
            this.tips = false
          } else {
            console.error('获取历史记录失败，状态码：', response.status)
          }
        } catch (error) {
          console.error('获取图像文件名失败：', error)
        }
      }
      const listenToProgress = (promptId) => {
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)
        this.ws.onopen = () => {
          console.log('提交服务器开始生成...')
          getTaskStart({
            type: T_IMAGE_SCALING,
            prompt: '',
            input_images: this.imagePath ? [this.imagePath] : []
          }).then(rep => {
            this.taskLogId = rep.data.task.id
          })
          clearTimeout(wsTimeout)
        }
        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              console.log(`这是返回${msg}`)
              if (msg.type === 'executing') {
                const data = msg.data
                if (data.node === null && data.prompt_id === promptId) {
                  this.ws.close()
                  await fetchImageFilename(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                const current = (value / max * 100).toFixed(2)
                this.tips = `大约完成：${current}%`
              }
            } catch (error) {
              console.log('获取结果失败，请重试')
              this.tips = false
            }
          }
        }
        this.ws.onclose = async () => {
          this.processing = false
          this.tips = false
          try {
            const index = cudaIndexNum()
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) { console.log(error) }
        }
      }
      (async () => {
        const result = await sendPromptRequest()
        if (result && result.prompt_id) {
          listenToProgress(result.prompt_id)
        }
      })()
    },
    async getTaskEnd(tmp, taskLogId) {
      const imgInfo = await getImageSizeByLoading(tmp)
      const info = {
        details: [{ path: tmp, imgInfo: imgInfo }]
      }
      getTaskEnd({ result: JSON.stringify(info) }, taskLogId)
    },
    // 查看输出图片大图（使用el-image组件，支持放大缩小）
    handleOutputImageClick() {
      if (!this.processedImage) return
      this.previewUrl = this.processedImage
      this.$nextTick(() => {
        this.$refs.previewImage.clickHandler()
      })
    },
    // 初始化效果
    source_html() {
      const main = document.querySelector('.content-wrapper')
      if (main) {
        main.style.opacity = this.theme === false ? 0.75 : 1
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

* { margin: 0; padding: 0; box-sizing: border-box; }

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

.app-container {
  width: 100vw;
  height: 100vh;
  background: #f5f7fa;
  overflow: hidden;
}

header {
  height: 95px;
  width: 100%;
  padding: 10px 30px;
  font-size: 18px;
  border-bottom: 1px solid #e5e7eb;
  background: white;

  .header-content {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo-section {
    width: 230px;
    height: 75px;
    display: flex;
    align-items: center;
    padding: 10px;
    img {
      width: 230px;
      object-fit: cover;
      cursor: pointer;
      transition: all 0.3s;
      &:hover { transform: scale(1.05); }
    }
  }

  .header-spacer { flex: 1; }

  .header-actions {
    display: flex;
    gap: 20px;
    align-items: center;

    .home-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: #ff8c42;
      color: white;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      font-weight: 500;
      .iconfont { font-size: 20px; }
      &:hover {
        background-color: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .header-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: rgba(39, 41, 46, 0.05);
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      color: #333;
      .iconfont { font-size: 20px; }
      &:hover {
        background-color: #f0f0f0;
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      }
    }

    .user-avatar {
      display: flex;
      width: 50px;
      height: 50px;
      border: 2px solid #e5e7eb;
      border-radius: 50%;
      overflow: hidden;
      justify-content: center;
      align-items: center;
      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;
        &:hover { transform: scale(1.1); }
      }
    }
  }
}

.body {
  width: 100vw;
  height: calc(100vh - 95px);
  background: #ffffff;
  padding: 40px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .content-wrapper {
    display: flex;
    gap: 50px;
    max-width: 1600px;
    margin: 0 auto;
    height: calc(100% - 140px);
  }

  .upload-section, .output-section {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .section-title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }

  .upload-card, .output-card {
    background: white;
    border-radius: 30px;
    padding: 30px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 600px;
  }

  .upload-area {
    position: relative;
    flex: 1;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    overflow: hidden;
    min-height: 300px;
    &:hover { border-color: #ff8c42; background: #fff8f3; }

    .close-btn {
      position: absolute;
      top: 15px; right: 15px;
      width: 32px; height: 32px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;
      &:hover { background: rgba(255, 0, 0, 0.8); transform: scale(1.1); }
    }

    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      .upload-icon { font-size: 60px; }
      .upload-text { font-size: 16px; color: #6c757d; }
      .upload-button {
        padding: 10px 30px;
        background: #ff8c42;
        color: white;
        border-radius: 25px;
        font-size: 16px;
        transition: all 0.3s;
        &:hover { background: #ff7a2e; transform: translateY(-2px); }
      }
    }

    .uploaded-image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .upload-tips {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-size: 14px;
    color: #6c757d;

    .tip-item {
      display: flex;
      gap: 10px;
      align-items: center;
      .tip-label { font-weight: 600; color: #495057; min-width: 60px; }
      .tip-value { color: #ff8c42; }
      .param-input {
        padding: 6px 12px;
        border: 2px solid #dee2e6;
        border-radius: 8px;
        font-size: 14px;
        color: #495057;
        background: white;
        width: 120px;
        outline: none;
        transition: all 0.3s;
        &:hover, &:focus { border-color: #ff8c42; }
        &:focus { box-shadow: 0 0 0 3px rgba(255, 140, 66, 0.15); }
      }
    }

    .tip-desc {
      line-height: 1.6;
      color: #868e96;
      margin-top: 5px;
    }
  }

  .output-area {
    position: relative;
    flex: 1;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 300px;

    .close-btn {
      position: absolute;
      top: 15px; right: 15px;
      width: 32px; height: 32px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;
      &:hover { background: rgba(255, 0, 0, 0.8); transform: scale(1.1); }
    }

    .output-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      .output-icon { font-size: 60px; opacity: 0.3; }
      .output-text { font-size: 16px; color: #adb5bd; }
    }

    .output-image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .processing-mask {
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 5;
      .processing-text { font-size: 18px; color: #ff8c42; font-weight: 600; }
    }
  }

  .output-tips {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
    color: #6c757d;

    .tip-item {
      display: flex;
      gap: 15px;
      .action-btn {
        flex: 1;
        padding: 12px;
        background: white;
        border: 2px solid #dee2e6;
        border-radius: 10px;
        text-align: center;
        font-size: 16px;
        color: #495057;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          border-color: #ff8c42;
          color: #ff8c42;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(255, 140, 66, 0.2);
        }
      }
    }

    .tip-desc { line-height: 1.6; color: #868e96; }
  }

  .bottom-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    margin-top: 70px;
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;

    .generate-btn {
      padding: 12px 100px;
      background: #ff8c42;
      color: white;
      border-radius: 30px;
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);
      &:hover {
        background: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(255, 140, 66, 0.6);
      }
      &:active { transform: translateY(0); }
    }

    .save-btn {
      padding: 12px 40px;
      background: white;
      color: #ff8c42;
      border: 2px solid #ff8c42;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background: #ff8c42;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .help-btn {
      position: relative;
      padding: 12px 40px;
      background: white;
      color: #a5a5a5;
      border: 2px solid #c7c7c7;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background: #ff8c42;
        color: white;
        border-color: #ff8c42;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }

      .help-tooltip {
        position: absolute;
        bottom: 70px;
        right: 0;
        width: 550px;
        max-height: 500px;
        overflow-y: auto;
        background: white;
        border-radius: 15px;
        padding: 25px;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        animation: fadeInUp 0.3s ease;
        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          right: 15px;
          width: 0; height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid white;
        }

        .tooltip-title {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #ff8c42;
        }

        .tooltip-content {
          font-size: 14px;
          line-height: 1.8;
          color: #555;
          .tip-section {
            margin-bottom: 15px;
            &:last-child { margin-bottom: 0; }
            .section-title {
              font-size: 16px;
              font-weight: 600;
              color: #ff8c42;
              margin-bottom: 8px;
            }
            p { margin: 6px 0; padding-left: 10px; color: #666; }
          }
        }
      }
    }
  }
}
</style>
